export const fixedHeight = {
  height: '60vh',
}

export const link = {
  color: 'black',
}
